export default __webpack_public_path__ + "static/media/right-heading.png?.7d5193cb";